import React from 'react';

import { flagStyles } from '../settings';

const SvgMK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3408px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgMK;
